import styled from 'styled-components';

export default styled.div`
  > div {
    height: 136px;
    display: flex;
    padding: 8px;

    div.daily-report-widget__left {
      margin-right: 12px;
      width: 100%;
      min-width: 110px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      border-radius: 10px;
      background-color: rgba(245, 245, 247, 1);

      img {
        display: block;
        margin: 0 auto;
        width: 33px;
        height: 48px;
      }
    }

    div.daily-report-widget__right {
      > span {
        color: rgba(41, 49, 88, 0.6);
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 24px;
        min-height: 40px;
        height: 24px;
      }

      > span:not(:first-child) {
        display: block;
        color: rgba(51, 61, 108, 1);
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 20px;
        margin-bottom: 24px;
      }
    }
  }
`;
